import type { PreferredContactGap } from '@ehr/shared';
import { ApiError } from '../lib/api.js';

/**
 * ehr#661: the fields a PREFERRED_CONTACT_EMPTY refusal names (to mark red), else null.
 * The preferred method first, then the field it needs.
 */
export function preferredContactRefusal(e: unknown): string[] | null {
  if (!(e instanceof ApiError) || e.code !== 'PREFERRED_CONTACT_EMPTY') return null;
  const fields = (e.details as { fields?: unknown } | undefined)?.fields;
  return Array.isArray(fields) && fields.length ? fields.map(String) : ['contact.preferredContact'];
}

/**
 * ehr#661 (Chase, 10-26): the client's preferred contact method has nothing to reach ("Preferred
 * contact is Mobile phone, but no mobile number is on file"), so reminders and outreach go
 * nowhere. Shown on the chart (Summary, Demographics > Contact Info) until someone fills the field
 * or picks another method; it never changes the record itself.
 */
export function PreferredContactWarning({
  gap,
  onFix,
}: {
  gap: PreferredContactGap;
  /** Opens Contact Info (the Summary's link); left out where the fields are already showing. */
  onFix?: () => void;
}) {
  return (
    <div className="pref-contact-warn" role="status">
      <svg
        width="15"
        height="15"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden
      >
        <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
        <line x1="12" y1="9" x2="12" y2="13" />
        <line x1="12" y1="17" x2="12.01" y2="17" />
      </svg>
      <span className="pref-contact-warn-text">
        <b>{gap.message}</b>
        {gap.defaulted ? ' (no method was picked, so the default applies)' : ''} Reminders and
        outreach can&apos;t reach this client that way. {gap.fillIn}
      </span>
      {onFix && (
        <button type="button" className="pref-contact-warn-fix" onClick={onFix}>
          Open Contact Info
        </button>
      )}
    </div>
  );
}
